import { ModelRow, StringUtil } from "@mcleod/core";
import { DataDisplayEvent, DataSourceMode, Label } from "@mcleod/components";
import { AutogenLayoutOtherChargeCompareItem } from "./autogen/AutogenLayoutOtherChargeCompareItem";

export class OtherChargeCompareItem extends AutogenLayoutOtherChargeCompareItem {

    private _compareItems: ModelRow[];

    public async setupTableData(data: ModelRow[]) {
        this._compareItems = data;
        const newTable = this.filterTable();
        if (newTable != null) {
            if (newTable.length === 0) {
                this.tableCompareItems.visible = false;
            } else {
                this.tableCompareItems.dataSource.setRowsAndMode(DataSourceMode.NONE, newTable);
            }
        }

    }

    override onLoad(): void | Promise<void> {
        this.tableCompareItems.dataSource = this.sourceEdiCompareItem;
    }

    onDescrDisplay(event: DataDisplayEvent) {
        const labelDescr = <Label>event.target
        if (StringUtil.isEmptyString(event.rowData.get("target_descr"))) {
            labelDescr.text = event.rowData.get("source_descr");
        }
    }

    private filterTable(): ModelRow[] {
        let newTable = [];
        if (this._compareItems?.length > 0) {
            const changeType = this._compareItems[0].get("change_type");
            if (changeType == "NO") {
                newTable = this._compareItems.filter(value => {
                    const sourceValue = value.get("source_value");
                    if (sourceValue !== null && sourceValue !== "" && sourceValue !== undefined) {
                        return value;
                    }
                });
            } else if (changeType == "OC") {
                newTable = this._compareItems.filter(value => {
                    const sourceValue = value.get("target_value");
                    if (sourceValue !== null && sourceValue !== "" && sourceValue !== undefined) {
                        return value;
                    }
                });
            }
            else {
                newTable = this._compareItems;
            }
        } else {
            newTable = this._compareItems;
        }
        return newTable;
    }
}
